export default "__VITE_ASSET__82b3d40e__"